import { DecimalPipe } from '@angular/common';
import { hasValue } from '@util/type';
import * as R from 'ramda';

interface PropToNumber {
  <T extends Record<K, number>, K extends keyof T>(key: K, obj: T): T[K];
  <K extends string>(key: K): <T extends Record<K, number>>(obj: T) => T[K];
}

const toNumber = R.ifElse(hasValue, Number, R.identity);
export const propToNumber: PropToNumber = R.curry((key, obj) =>
  toNumber(R.prop(key, obj))
);

const hasDecimal = (value: number) => value % 1 !== 0;
export const toFixedDecimals = (value: number, givenDecimals: number): string => {
  const decimals = hasDecimal(value) ? givenDecimals : 0;
  return new DecimalPipe('en-US').transform(value, `1.${decimals}-${decimals}`);
};

export const isNumeric = (n: string): boolean => {
  if (!hasValue(n)) {
    return false;
  }
  const trimmed = R.trim(n);
  return trimmed.length > 0 && Number.isFinite(Number(trimmed));
};
